export default async function showConfirmationPopup(message = "Sei sicuro?",) {
    return swal({
        title: "Conferma",
        text: message,
        icon: "warning",
        buttons: ["Annulla", "Conferma"],
        dangerMode: true,
    })
}
